import { useState } from "react";
import { Button, Checkbox, CircularProgress, List, ListItemButton, ListItemIcon, ListItemText, Typography } from "@mui/material";
import { useMutation } from 'react-query'
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { duplicate } from "../services/api";
import { useTranslation } from "react-i18next";

export default function Copy({ open, close, menu, menusList, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [checked, setChecked] = useState([]);
  console.log("copy menusList", menusList)

  const mutation = useMutation(duplicate, {
    onSuccess: (data) => {
      setIsLoading(false)
      if (data.status === "error") { reportAction(false, 'Error al guardar los datos') }
      else { setChecked([]); reportAction(true, 'Acción realizada correctamente'); }
    }
  })

  const handleCopy = () => {
    setIsLoading(true)
    mutation.mutate({ id: instance._id, menuId: menu, params: checked })
  }

  const handleClose = () => { setChecked([]); close() }

  const handleMenuSelect = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) { newChecked.push(value) }
    else { newChecked.splice(currentIndex, 1) }
    setChecked(newChecked);
  };

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t("button_text_cancel")}</Button>
      <Button variant="contained" onClick={() => handleCopy()}>{t("button_text_copy")}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    {open ?
      <FlexibleWidthDialog open={open} title={t('promotions_dialog_title_copy')} actions={<Actions />}>
        <Typography variant="body1" component="p"> {t("promotions_dialog_instrucions_copy_text")} </Typography>
        {(menusList !== null && menusList !== undefined) &&
          <List>
            {menusList.map((item) => {
              return (<>
                {menu !== item._id ?
                  <ListItemButton key={`item-copy-${menu._id}-${item._id}`} role={undefined} onClick={handleMenuSelect(item._id)}>
                    <ListItemIcon>
                      <Checkbox edge="start" tabIndex={-1} disableRipple
                        inputProps={{ 'aria-labelledby': item._id }}
                        checked={checked.indexOf(item._id) !== -1}
                      />
                    </ListItemIcon>
                    <ListItemText id={item._id} primary={item.name} />
                  </ListItemButton>
                  : null}
              </>)
            })}
          </List>}
      </FlexibleWidthDialog>
      : null}
  </>)
}